import { IeBookingContext } from '../../ieBookingContext'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'

/**
 * bookingWorkspace的Context
 */
export class BookingWorkspaceContext extends IeBookingContext {
  /**
   * constructor
   */
  constructor(obj) {
    super(obj)
  }
  get userList() {
    return getCacheListByKey(basicCacheKeys.basic_data_User)
  }
  set userList(userList) {
    // ignore
  }
  get companyList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Company)
  }
  set companyList(companyList) {
    // ignore
  }
  get seaPortList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Seaport)
  }
  set seaPortList(seaPortList) {
    // ignore
  }
  get regionList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Region)
  }
  set regionList(regionList) {
    // ignore
  }
  get paymentTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
  }
  set paymentTermList(paymentTermList) {
    // ignore
  }
  get packingList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Packing)
  }
  set packingList(packingList) {
    // ignore
  }
  get shippingTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
  }
  set shippingTermList(shippingTermList) {
    // ignore
  }
  get blModeList() {
    return getCacheListByKey(basicCacheKeys.basic_data_BlMode)
  }
  set blModeList(blModeList) {
    // ignore
  }
  get modifiedData() { // 在页面中看不到，但被联动修改了的实体数据
    return this._data.modifiedData
  }
  set modifiedData(modifiedData) {
    this._data.modifiedData = modifiedData
  }
  get removedData() { // 被删除了的实体数据
    return this._data.removedData
  }
  set removedData(removedData) {
    this._data.removedData = removedData
  }
}
